module.exports = {
      id: "author-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#author",
      toString: function () {
        return this.url;
      }
    }